import { createFileRoute } from "@tanstack/react-router";
import { ToolCallPatterns } from "@/routes/help/tool-call-patterns";

export const Route = createFileRoute("/dashboard/help/tool-call-patterns")({
	component: ToolCallPatterns,
});
